import React from 'react';
import classNameBind from 'classnames/bind';
import styles from './Label.module.css';

const bindClasses = classNameBind.bind(styles);

const Label = ({
  className,
  children,
  type,
  htmlFor,
  noSelect,
  required,
  disabled,
  noWrap,
  cutText,
  title,
  showWhiteSpace,
  cursorDisabled,
}) => {
  const nodeType = htmlFor ? 'label' : 'div';
  const classes = bindClasses('label', type, {
    htmlFor: !disabled && htmlFor,
    'no-select': noSelect,
    disabled,
    'no-wrap': noWrap,
    required,
    'cut-text': cutText,
    showWhiteSpace,
    cursorDisabled,
  });

  return (
    React.createElement(nodeType, {
      'data-ppuc-id': 'Label',
      className: `${className} ${classes}`,
      htmlFor,
      disabled,
      title: title !== null ? title : children,
    }, children)
  );
};

Label.defaultProps = {
  className: '',
  type: 'default',
  htmlFor: null,
  noSelect: false,
  disabled: false,
  noWrap: false,
  required: false,
  cutText: false,
  title: null,
  showWhiteSpace: false,
  cursorDisabled: false,
};

export default Label;
